import type { Catalog, ExtraKeys, UnknownSlotKeys } from '../catalog';
import { account } from './de/account';
import { acts } from './de/acts';
import { common } from './de/common';
import { kit } from './de/kit';
import { legacy } from './de/legacy';
import { notes } from './de/notes';
import { push } from './de/push';
import { resolution } from './de/resolution';
import { suggestions } from './de/suggestions';
import { shell } from './de/shell';
import { palette } from './de/palette';
import { create } from './de/create';
import { auth } from './de/auth';
import { pickers } from './de/pickers';
import { itemActions } from './de/itemActions';
import { viewControls } from './de/viewControls';
import { criteria } from './de/criteria';
import { values } from './de/values';
import { feed } from './de/feed';
import { checklist } from './de/checklist';
import { fields } from './de/fields';
import { access } from './de/access';
import { contacts } from './de/contacts';
import { agentKeys } from './de/agentKeys';
import { item } from './de/item';
import { lists } from './de/lists';
import { lenses } from './de/lenses';
import { work } from './de/work';
import { views } from './de/views';
import { search } from './de/search';
import { tags } from './de/tags';
import { map } from './de/map';
import { admin } from './de/admin';
import { groups } from './de/groups';
import { invite } from './de/invite';
import { connect } from './de/connect';
import { flows } from './de/flows';
import { boards } from './de/boards';
import { phases } from './de/phases';
import { ceremonies } from './de/ceremonies';
import { plans } from './de/plans';
import { attributes } from './de/attributes';
import { facts } from './de/facts';
import { modules } from './de/modules';
import { mail } from './de/mail';
import { flowErrors } from './de/flowErrors';
import { itemErrors } from './de/itemErrors';
import { accessErrors } from './de/accessErrors';
import { accountErrors } from './de/accountErrors';
import { proposalErrors } from './de/proposalErrors';

/**
 * **The German catalog** (docs/I18N.md; its words are the glossary's,
 * src/i18n/glossary.ts). Complete at typecheck: `satisfies Catalog` fails on a
 * key English has and German lacks, and the two assertions below fail on a key
 * German has and English lacks, and on a German template that names a slot the
 * English entry does not have. There is no runtime fallback to English.
 */
export const de = {
  ...common,
  ...kit,
  ...account,
  ...acts,
  ...resolution,
  ...push,
  ...suggestions,
  ...notes,
  ...legacy,
  // stage 2, slot components-a (docs/I18N.md §11)
  ...shell,
  ...palette,
  ...create,
  ...auth,
  ...pickers,
  ...itemActions,
  ...viewControls,
  ...criteria,
  ...values,
  // stage 2, slot components-b (docs/I18N.md §11)
  ...feed,
  ...checklist,
  ...fields,
  ...access,
  ...contacts,
  ...agentKeys,
  // stage 2, slot item (docs/I18N.md §11)
  ...item,
  // stage 2, slot views (docs/I18N.md §11)
  ...lists,
  ...lenses,
  ...work,
  ...views,
  ...search,
  ...tags,
  ...map,
  // stage 2, slot people (docs/I18N.md §11)
  ...admin,
  ...groups,
  ...invite,
  ...connect,
  // stage 2, slot flows (docs/I18N.md §11)
  ...flows,
  ...boards,
  ...phases,
  ...ceremonies,
  ...plans,
  // stage 2, the words the domain and src/lib hand the surfaces
  ...attributes,
  ...facts,
  ...modules,
  ...mail,
  // stage 2, the refusals outside the resolver (docs/I18N.md §6)
  ...flowErrors,
  ...itemErrors,
  ...accessErrors,
  ...accountErrors,
  ...proposalErrors,
} as const satisfies Catalog;

/** `true` only while German carries no key English lacks. */
export const deHasNoExtraKeys: [ExtraKeys<typeof de>] extends [never]
  ? true
  : ExtraKeys<typeof de> = true;
/** `true` only while every German template names only English slots. */
export const deSlotsMatch: [UnknownSlotKeys<typeof de>] extends [never]
  ? true
  : UnknownSlotKeys<typeof de> = true;
